import React from 'react';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
const PlaceYourOrder = () =>
{
	return (
		<div className='poBdy flexCol'>
			<div className='flexCol pdngXS'>
				<h1 className='mainHdngTxtSM'>Place your order</h1>
				<div className='flexCol brdrBlackSM brdrRadiusSM pdngMD'>
					<h3 className='subHeadingSM'>Your Details</h3>
					<p className='wordBreakAll pdngVXS capitalTxt'>santhoshi</p>
					<span className='wordBreakAll'>
						santhoshi@peoplelinkvc.com
					</span>
				</div>
				<div className='flexCol whiteBg pdngMD brdrRadiusSM brdrBlackSM mrgnVSM'>
					<h3 className='subHeadingSM'>Order Summary</h3>
					<div className='flexRow baseBg pdngSM brdrRadiusXS mrgnVXS'>
						<div className='flexMinWidthRow' >
							<span className='subHeadingSM'>InLynk Concurrent Plan</span>
						</div>
						<div className='flexAutoRow alignCntr'>
							<span className='lightTxt'>No of users :</span>&nbsp;&nbsp;&nbsp;
							<input type='text' min='84' max='50000' className='countInput' value='2' />
							<ButtonGroup
								disableElevation
								variant='contained'
								aria-label='Disabled elevation buttons'
							>
								<Button disableElevation disableRipple className='whiteTxt' size='small'>
									<HorizontalRuleIcon />
								</Button>
								<Button disableElevation disableRipple className='whiteTxt' size='small'><AddIcon /></Button>
							</ButtonGroup>
						</div>
					</div>
					<div className='flexRow'>
						<span className='lightTxt pdngVXS'>InLynk Concurrent Plan </span>
					</div>
					<div className='flexCol brdrBSM pdngVXS'>
						<div className='flexRow'>
							<div className='flexMinWidthRow'>
								<span className='lightTxt'>License Cost:</span>
							</div>
							<div className='flexAutoRow'>
								<b>$120.00</b>
							</div>
						</div>
						<div className='flexRow'>
							<div className='flexMinWidthRow'>
								<span className='lightTxt'>Taxes (GST 18%):</span>
							</div>
							<div className='flexAutoRow'>
								<b>$21.60</b>
							</div>
						</div>
					</div>
					<div className='flexRow pdngVXS'>
						<div className='flexMinWidthRow'>
							<span>Total:</span>
						</div>
						<div className='flexAutoRow'>
							<b>$141.60</b>
						</div>
					</div>
				</div>
				<div className='flexRow justifyEnd mrgnVMD'>
					<Button variant='contained' className='whiteTxt' disableElevation disableRipple disableFocusRipple>Place Your Order Now!</Button>
				</div>
				<div className='flexRow alignCntr justifyCntr'>
					<small className='hintTxt'>When you place an order, we will send you an e-mail message acknowledging a receipt of your order.</small>
				</div>
			</div>
		</div>
	);
};

export default PlaceYourOrder;